module.exports = "/assets/1f5419578b75d1d9967a76bf3b35899c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AA.png
// module id = 2317
// module chunks = 0